import { IFontData, IWidgetVisibility, Orientation, SelfPosition, VisibilityData, WidgetPlaceType } from "./index";
import { IAnimatedWidget } from "./widget-style-data";

export interface ISocialLinksWidgetData extends IWidgetVisibility {
    readonly type: "SocialLinksWidget";
    placeType: WidgetPlaceType;
    id?: string | null;
    links: ISocialLinkData[];
    alignment: SelfPosition;
    linkStyles: ILinkStyles;
    orientation: Orientation;
    displayStyle: SocialLinkDisplayStyle;
    colorOptions: SocialLinkColorOptions;
    style: ISocialLinksWidgetStyle | null;
}

export enum SocialLinkDisplayStyle {
    OnlyIcons = "onlyIcons",
    IconsWithUsername = "iconsWithUsername"
}

export enum SocialLinkColorOptions {
    Default = "default",
    Custom = "custom"
}

export interface ISocialLinksWidgetStyle extends IAnimatedWidget {
    font?: IFontData | null;
    iconsColor?: string | null;
}

export interface ISocialLinkData {
    socialNetwork: SocialNetwork;
    text: string;
    enabled: boolean;
}

export interface ILinkStyles {
    iconSize: number;
    padding: number;
}

export enum SocialNetwork {
    Facebook = "facebook",
    X = "x",
    Instagram = "instagram",
    YouTube = "youTube",
    LinkedIn = "linkedIn",
    TikTok = "tikTok",
    Pinterest = "pinterest"
}

export abstract class SocialLinksWidgetData {

    public static get defaultData(): ISocialLinksWidgetData {
        return {
            type: "SocialLinksWidget",
            placeType: "Section",
            links: this.links,
            alignment: "center",
            linkStyles: this.linkStyles,
            orientation: Orientation.Horizontal,
            displayStyle: SocialLinkDisplayStyle.OnlyIcons,
            colorOptions: SocialLinkColorOptions.Default,
            visibility: VisibilityData.defaultData(),
            style: this.defaultStyle
        };
    }

    public static get defaultStyle(): ISocialLinksWidgetStyle {
        return {
            animation: {
                animationSource: "site-design",
                animationData: {
                    name: "none",
                    duration: 1
                }
            },
            font: {
                weight: "",
                family: "",
                size: "",
                lineHeight: ""
            },
            iconsColor: "#12A3F8"
        };
    }

    private static get links(): ISocialLinkData[] {
        return [
            { socialNetwork: SocialNetwork.Facebook, text: "https://www.facebook.com/Truvisibility", enabled: true },
            { socialNetwork: SocialNetwork.X, text: "https://www.x.com/Truvisibility", enabled: true },
            { socialNetwork: SocialNetwork.Instagram, text: "https://www.instagram.com/Truvisibility", enabled: true },
            { socialNetwork: SocialNetwork.YouTube, text: "https://www.youtube.com/company/Truvisibility", enabled: true },
            { socialNetwork: SocialNetwork.LinkedIn, text: "https://www.linkedin.com/company/Truvisibility", enabled: true },
            { socialNetwork: SocialNetwork.TikTok, text: "https://www.tiktok.com/Truvisibility", enabled: true },
            { socialNetwork: SocialNetwork.Pinterest, text: "https://www.pinterest.com/Truvisibility", enabled: true },
        ];
    }

    private static get linkStyles(): ILinkStyles {
        return {
            iconSize: 42,
            padding: 16,
        };
    }

}

export interface ISocialLinksWidgetDataShort {
    links: ISocialLinkData[];
}
